import React, { ReactElement } from 'react';
import classnames from 'classnames';
import './SearchList.scss';
import { SearchEntity } from 'v2/models';
import { ColumnOptions, Columns } from 'v2/utils/searchViewUtils';
import SortableColumn from '../SortableColumn/SortableColumn';
import { useMasterOrganization } from 'v2/queries';
import styles from './styles.module.scss';
import { useFreeUser } from 'v2/hooks/useFreeUser';
import UnqualifiedMsg from '../UnqualifiedMsg/UnqualifiedMsg';

interface SearchListProps {
  columns: Columns;
  data: SearchEntity[];
  className?: string;
  renderSearchItem: (search: SearchEntity, columns: Columns) => ReactElement;
  currentSortField?: string;
  onSortChange?: (field: string) => void;
}

interface BasicColumnProps {
  column: ColumnOptions;
}

const BasicColumn = ({ column }: BasicColumnProps) => {
  return (
    <p key={column.type} className={classnames('no-wraping-text')}>
      {column.label}
    </p>
  );
};

const SearchList = ({
  columns,
  data,
  className,
  renderSearchItem,
  currentSortField,
  onSortChange,
}: SearchListProps) => {
  const activeColumns = columns.filter((c) => !c.disabled);
  const { data: masterOrganization } = useMasterOrganization();
  const [isFreeUser] = useFreeUser();
  if (isFreeUser && masterOrganization?.unqualified) {
    return <UnqualifiedMsg />;
  }
  return (
    <>
      <div
        className={classnames(
          'position-relative',
          styles.listContainer,
          className
        )}
      >
        <div role="list" data-cy="active-requests-list">
          <div
            className={classnames(
              'search-header',
              `search-col-${activeColumns.length}`
            )}
          >
            {activeColumns.map((column) => (
              <React.Fragment key={column.type}>
                {column.sortable ? (
                  <SortableColumn
                    label={column.label}
                    ascField={column.ascField || ''}
                    descField={column.descField || ''}
                    currentField={currentSortField}
                    onSortChange={(field) => onSortChange?.(field)}
                  />
                ) : (
                  <BasicColumn column={column} />
                )}
              </React.Fragment>
            ))}
          </div>
          {data.map((search) => renderSearchItem(search, activeColumns))}
        </div>
      </div>
    </>
  );
};

export default SearchList;
